import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import {
  sportAnalyticTag,
  useSportContext,
} from '@sorare/core/src/contexts/sport';
import { MarketRoot } from '@sorare/marketplace/src/components/market/ui';
import {
  SCOUTING_CENTER_CONFIG_BY_SPORT,
  SCOUTING_CENTER_OWNED_CARDS_RARITIES,
} from '@sorare/marketplace/src/lib/scoutingCenterFilters';
import {
  AdvancedPlayerSearch,
  BackendAdvancedPlayerSearch,
} from '@sorare/marketplace/src/searchCommonPlayer/AdvancedPlayerSearch';

import { Header } from '#src/components/scoutingCenter/stats/Header/index.tsx';

export const ScoutingCenter = () => {
  const { sport } = useSportContext();
  const scoutingConfig = SCOUTING_CENTER_CONFIG_BY_SPORT[sport];
  const {
    sorts,
    filters,
    dropdownFilters,
    backendCardFilters,
    backendDropdownFilters,
  } = scoutingConfig;

  return (
    <MarketRoot>
      <Vertical gap={3}>
        <Header sport={sport} />
        <div>
          {backendCardFilters && backendDropdownFilters ? (
            <BackendAdvancedPlayerSearch
              sport={sport}
              defaultHitsPerPage={20}
              sorts={sorts}
              defaultSort={sorts[0]}
              cardFilters={backendCardFilters}
              dropdownFilters={backendDropdownFilters}
              analyticsTags={['Scouting-center', sportAnalyticTag[sport]]}
              topic={{ type: 'scoutingCenter', label: '' }}
              attributesToRetrieve={['slug']}
              lastOwnedCardsRarities={SCOUTING_CENTER_OWNED_CARDS_RARITIES}
            />
          ) : (
            <AdvancedPlayerSearch
              sport={sport}
              defaultHitsPerPage={20}
              sorts={sorts}
              defaultSort={sorts[0]}
              cardFilters={filters}
              dropdownFilters={dropdownFilters}
              analyticsTags={['Scouting-center', sportAnalyticTag[sport]]}
              topic={{ type: 'scoutingCenter', label: '' }}
              attributesToRetrieve={['slug']}
              lastOwnedCardsRarities={SCOUTING_CENTER_OWNED_CARDS_RARITIES}
            />
          )}
        </div>
      </Vertical>
    </MarketRoot>
  );
};
